import { combineReducers } from "redux"
import todoReducer from "./todo/"
import customizer from "./customizer/"
import auth from "./auth/"
import nft from "./nft/nft_reducer"
import socket from "./socket/socket_reducer"
import authorizedUserReducer from "./user";
import sdStateReducers from './sd/sd_redusers'

const rootReducer = combineReducers({
  todoApp: todoReducer,
  customizer: customizer,
  auth: auth,
  authorizedUser: authorizedUserReducer,
  nft:nft,
  socket:socket,
  sdState: sdStateReducers, 
});

export default rootReducer
